import { createGlobalStyle } from "styled-components";
import { rgba } from "polished";
import theme from './theme';

// console.log( theme.cultPalette );
const globalStyle = createGlobalStyle`
  html, body {
    background-color: #000000;
  }

  body {
    color: #ffffff !important;
  }

  p, .p {
    margin-bottom: 0;
  }

  ul,.ul{
    list-style: none;
    margin: 0;
    padding: 0;
  }


  a {
    transition: all 0.3s ease-out;
    &:hover, &:active, &:focus{
      text-decoration: none !important;
      outline: none !important;
    }

    color: ${theme.cultPalette[1] === '#950AFF' ? '#13FFED':theme.cultPalette[2]};
    text-shadow: 1px 1px 0px #000;
    cursor: pointer;

    &:hover {
      color: ${theme.cultPalette[0]};
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }



// ~~~~~~~~~~ LUX STYLES ~~~~~~~~~~

  // HACKER STYLE : panels + buttons run dark — near-black fills, the
  // cultPalette colors moved from backgrounds into text + thin borders,
  // chunky offset shadows swapped for a soft neon glow in the same color.
  // The random palette mechanic is untouched; colors just land differently.

  // CULT PANEL + TEXTBOXES
    .cult-panel,
    .cult-panel-colors {
      background: ${rgba('#000000', 1)};
      color: ${theme.cultPalette[1]};
      text-shadow: 0 0 8px ${rgba(theme.cultPalette[1], 0.45)};
    }
    .cult-panel {
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 5px 20px;
      text-transform: uppercase;
      box-shadow: 0 0 12px ${rgba(theme.cultPalette[1], 0.18)};
      font-weight: bold;
      font-size: 18px;
      @media (max-width: 767px) { font-size: 16px; }
      font-family: 'pixel9';
      text-align: center;
      border: 1px solid #343a40;
      transition: all 0.2s ease-in-out;
    }


  // CULT BUTTON
    .site-wrapper .cult-button,
    .cult-button-colors {
      background: ${rgba('#000000', 0.85)};
      color: ${theme.cultPalette[0]};
      text-shadow: 0 0 8px ${rgba(theme.cultPalette[0], 0.45)};
      border-color: ${theme.cultPalette[0]};
    }

    .site-wrapper .cult-button-alt-colors {
      background: ${rgba('#000000', 0.85)};
      color: ${theme.cultPalette[2]};
      text-shadow: 0 0 8px ${rgba(theme.cultPalette[2], 0.45)};
      border-color: ${theme.cultPalette[2]};
    }

    .cult-button {
      padding: 5px 20px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 26px;
      @media (max-width: 767px) { font-size: 24px; }
      font-family: 'pixel9';
      border: 1px solid ${theme.cultPalette[0]};
      box-shadow: 0 0 10px ${rgba(theme.cultPalette[0], 0.25)};
      cursor: pointer;
      transition: all 0.25s ease-in-out;

      /* hover inverts: fill with the accent, black text, glow up */
      &:hover {
        background: ${theme.cultPalette[0]} !important;
        color: #000 !important;
        text-shadow: none !important;
        box-shadow: 0 0 18px ${rgba(theme.cultPalette[0], 0.55)};
      }
    }

    .site-wrapper .cult-button-alt-colors:hover {
      background: ${theme.cultPalette[2]} !important;
      box-shadow: 0 0 18px ${rgba(theme.cultPalette[2], 0.55)};
    }

    .cult-button-subheader {
      pointer-events: none;
      width: auto;
      font-size: 20px;
      @media (max-width: 767px) { font-size: 18px; }
      display: inline;
    }

    .cult-input-error {
      background: ${rgba('#000000', 0.85)};
      color: ${theme.cultPalette[2]};
      text-shadow: 0 0 8px ${rgba(theme.cultPalette[2], 0.45)};
      border-color: ${theme.cultPalette[2]};
    }

    .cult-active-border:focus {
      outline-color: ${theme.cultPalette[0]};
    }

    .site-wrapper a,
    .cult-link { 
      color: ${theme.cultPalette[1] === '#950AFF' ? '#13FFED':theme.cultPalette[2]};
      text-shadow: 1px 1px 0px #000;
      cursor: pointer;

      &:hover {
        color: ${theme.cultPalette[0]};
      }
    }

    .cult-eye-ball { 
      background-color: ${theme.cultPalette[0]};
    }

    .cult-eye-pupil {
      background-color: ${theme.cultPalette[2]};
    }
`;

export default globalStyle;
